import { getUrlParams, pushUrlParams} from "./service-url-params";

export function typeAhead(query, typeaheadquery, container, searchcontainer){
  let fullQuery = `${typeaheadquery}?q=${query}`
    var myHeaders = new Headers();
    myHeaders.append("Cookie", "ASP.NET_SessionId=l2f0euhrzotgfqpkdmmk0qas");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(fullQuery, requestOptions)
    .then(response => response.json())
    .then(result => {      
      buildTypeAhead(result,container, searchcontainer)
    })
    .catch(error => console.log('error', error));
}

export function buildTypeAhead(json,container,searchcontainer){
  let ul = container.querySelector("ul");
    const result = json.map(Terms =>{
      return `<li class="cursor-pointer hover:bg-blue-10 py-2 px-6">${Terms.Term}</li>`
    }).join(" ");

    if (ul && json.length > 0){
      container.classList.remove("h-0");
      container.classList.add("h-auto");
      ul.innerHTML = result;
      let suggeations = ul.querySelectorAll("li");
      suggeations.forEach(suggestion =>{
        suggestion.addEventListener("click", e =>{
          let params = getUrlParams();
          container.classList.add("h-0");
          container.classList.remove("h-auto");
          searchcontainer.value = suggestion.innerText;
          params.query = suggestion.innerText;
          pushUrlParams(params);   
          searchcontainer.dispatchEvent(new KeyboardEvent('keypress', {'key': 'Enter'}));
        })
      })
    }
}